module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }